(function(){
  /* ============================================================
     PLACEHOLDER INCI — REPLACE BEFORE LAUNCH
     Only two entries are researched and real:
       - Tea tree leaf water at position 2
       - Niacinamide at position 9 of 44
     Everything else is illustrative. The ingredient checker reads
     straight from this array, so it is exactly as honest as what
     you put in it. Replace with the list off the carton.
     ============================================================ */
  var INCI = [
    "Water","Melaleuca Alternifolia (Tea Tree) Leaf Water","Glycerin","Propanediol",
    "Dipropylene Glycol","1,2-Hexanediol","Butylene Glycol","Panthenol","Niacinamide",
    "Beta-Glucan","Sodium Hyaluronate","Hydrolyzed Hyaluronic Acid","Allantoin",
    "Polydeoxyribonucleotide (Vegan PDRN)","Oryza Sativa (Rice) Bran Extract",
    "Centella Asiatica Extract","Madecassoside","Asiaticoside","Madecassic Acid",
    "Asiatic Acid","Tannic Acid","Coptis Japonica Root Extract","Ceramide NP",
    "Sodium Citrate","Citric Acid","Tromethamine","Carbomer",
    "Acrylates/C10-30 Alkyl Acrylate Crosspolymer","Xanthan Gum",
    "Ammonium Acryloyldimethyltaurate/VP Copolymer","Hydroxyacetophenone",
    "Ethylhexylglycerin","Disodium EDTA","Sodium Benzoate","Potassium Sorbate",
    "Pentylene Glycol","Glyceryl Glucoside","Trehalose","Betaine","Arginine",
    "Sodium PCA","Hydrolyzed Sodium Hyaluronate","Sodium Acetylated Hyaluronate","Zinc PCA"
  ];
  var KEY = ["Melaleuca Alternifolia (Tea Tree) Leaf Water","Niacinamide",
             "Polydeoxyribonucleotide (Vegan PDRN)","Beta-Glucan","Glycerin",
             "Panthenol","Propanediol"];
  var REMOVED = ["polyglyceryl-3 stearate","glycine soja sterols","peg-40 castor oil"];
  var ABSENT = [
    {t:["fragrance","parfum","perfume","essential oil","linalool","limonene","citral","geraniol"],
     m:"This formula is fragrance-free. No fragrance, parfum or essential oils."},
    {t:["coconut","shea","jojoba","argan","squalane","olive","sunflower","almond","avocado","cocoa","oil","butter"],
     m:"No plant oils or butters in this formula — it hydrates by binding water instead."},
    {t:["myristate","palmitate","stearate","laurate","polysorbate","ester","lauric","oleic"],
     m:"No fatty esters in this formula."},
    {t:["benzoyl peroxide","salicylic","adapalene","retinol","tretinoin","azelaic","differin"],
     m:"Not in this formula. This is a moisturizer, not an acne treatment — it contains no acne medication."},
    {t:["alcohol denat","denatured alcohol","sd alcohol"],
     m:"No drying alcohols in this formula."}
  ];

  function norm(s){ return (s||'').toLowerCase().replace(/[^a-z0-9]+/g,' ').trim(); }

  var list = document.getElementById('pp-inci');
  if(list){
    INCI.forEach(function(name,i){
      var li = document.createElement('li');
      var isKey = KEY.indexOf(name) > -1;
      li.innerHTML = '<span class="pp-n">'+(i+1)+'</span><span class="'+(isKey?'pp-key':'')+'">'+name+'</span>';
      list.appendChild(li);
    });
  }

  function say(v, cls, icon, html){
    v.className = 'pp-verdict' + (cls ? ' ' + cls : '');
    var t = document.getElementById('pp-vtext');
    var u = v.querySelector('use');
    if(u) u.setAttribute('href', '#' + icon);
    if(t) t.innerHTML = html; else v.innerHTML = html;
  }

  function check(q){
    var qEl = document.getElementById('pp-q');
    var v = document.getElementById('pp-verdict');
    if(!v) return;
    if(typeof q === 'string' && qEl){ qEl.value = q; }
    var n = norm(qEl ? qEl.value : q);
    if(!n){ say(v,'','i-search','Type an ingredient name to check it.'); return; }

    for(var i=0;i<REMOVED.length;i++){
      var r = norm(REMOVED[i]);
      if(r.indexOf(n)>-1 || n.indexOf(r)>-1){
        say(v,'pp-out','i-x','<b>Not in this formula.</b> It was in the older version — one of the three ingredients removed in the renewed formula.');
        return;
      }
    }
    for(var j=0;j<INCI.length;j++){
      if(norm(INCI[j]).indexOf(n)>-1){
        say(v,'pp-in','i-check','<b>Yes — '+INCI[j]+' is in this formula.</b><span class="pp-pos">Position '+(j+1)+' of '+INCI.length+'</span>');
        return;
      }
    }
    for(var k=0;k<ABSENT.length;k++){
      for(var m=0;m<ABSENT[k].t.length;m++){
        if(n.indexOf(ABSENT[k].t[m])>-1){
          say(v,'pp-out','i-x','<b>Not in this formula.</b> '+ABSENT[k].m);
          return;
        }
      }
    }
    say(v,'pp-out','i-x','<b>Not on the ingredient list.</b> The complete list is below — '+INCI.length+' ingredients, nothing omitted.');
  }
  var go=document.getElementById('pp-go'), qi=document.getElementById('pp-q');
  if(go) go.addEventListener('click',function(){check();});
  if(qi) qi.addEventListener('keydown',function(e){ if(e.key==='Enter'){ e.preventDefault(); check(); } });
  document.querySelectorAll('.pp-qchip').forEach(function(c){
    c.addEventListener('click',function(){ check(c.getAttribute('data-q')); });
  });

  /* ---- review carousel ---- */
  document.querySelectorAll('[data-car]').forEach(function(car){
    var rail=car.querySelector('[data-rail]');
    var prev=car.querySelector('.pp-car-prev');
    var next=car.querySelector('.pp-car-next');
    var dots=car.querySelector('[data-dots]');
    if(!rail) return;
    var cards=rail.children;

    function step(){
      if(!cards.length) return 300;
      var r=cards[0].getBoundingClientRect();
      var gap=parseFloat(getComputedStyle(rail).columnGap||getComputedStyle(rail).gap||16)||16;
      return r.width+gap;
    }
    function perView(){ return Math.max(1, Math.round(rail.clientWidth/step())); }
    function pages(){ return Math.max(1, cards.length-perView()+1); }

    if(dots){
      for(var i=0;i<pages();i++){
        var b=document.createElement('button');
        b.type='button';
        b.setAttribute('aria-label','Go to review '+(i+1));
        (function(n){ b.addEventListener('click',function(){ rail.scrollTo({left:n*step(),behavior:'smooth'}); }); })(i);
        dots.appendChild(b);
      }
    }
    function sync(){
      var idx=Math.round(rail.scrollLeft/step());
      if(dots) Array.prototype.forEach.call(dots.children,function(d,i){
        d.setAttribute('aria-current', i===idx ? 'true':'false');
      });
      if(prev) prev.disabled = rail.scrollLeft < 6;
      if(next) next.disabled = rail.scrollLeft > rail.scrollWidth-rail.clientWidth-6;
    }
    if(prev) prev.addEventListener('click',function(){ rail.scrollBy({left:-step(),behavior:'smooth'}); });
    if(next) next.addEventListener('click',function(){ rail.scrollBy({left:step(),behavior:'smooth'}); });
    rail.addEventListener('scroll',function(){
      clearTimeout(rail._t); rail._t=setTimeout(sync,90);
    },{passive:true});
    window.addEventListener('resize',function(){ clearTimeout(rail._r); rail._r=setTimeout(sync,150); },{passive:true});
    sync();
  });

  /* ---- how-to stepper ---- */
  document.querySelectorAll('[data-stepper]').forEach(function(g){
    var btns=g.querySelectorAll('[data-step]');
    btns.forEach(function(b){
      b.addEventListener('click',function(){
        var n=b.getAttribute('data-step');
        btns.forEach(function(o){o.setAttribute('aria-pressed', o===b?'true':'false')});
        g.querySelectorAll('[data-panel]').forEach(function(p){
          p.classList.toggle('pp-act', p.getAttribute('data-panel')===n);
        });
      });
    });
  });

  /* ---- interactive timeline ---- */
  document.querySelectorAll('[data-timeline]').forEach(function(g){
    var btns=g.querySelectorAll('[data-t]');
    btns.forEach(function(b){
      b.addEventListener('click',function(){
        var n=b.getAttribute('data-t');
        btns.forEach(function(o){o.setAttribute('aria-pressed', o===b?'true':'false')});
        g.querySelectorAll('[data-tp]').forEach(function(p){
          p.classList.toggle('pp-act', p.getAttribute('data-tp')===n);
        });
      });
    });
  });

  /* ---- problem -> resolution swap ---- */
  document.querySelectorAll('[data-swap] .pp-swap-i').forEach(function(b){
    b.addEventListener('click',function(){
      b.setAttribute('aria-pressed', b.getAttribute('aria-pressed')==='true' ? 'false':'true');
    });
  });

  /* ---- mechanism toggle ---- */
  document.querySelectorAll('[data-mech]').forEach(function(g){
    var btns=g.querySelectorAll('.pp-mech-toggle button');
    btns.forEach(function(b){
      b.addEventListener('click',function(){
        var side=b.getAttribute('data-side');
        btns.forEach(function(o){o.setAttribute('aria-pressed', o===b?'true':'false')});
        g.querySelectorAll('[data-panel]').forEach(function(p){
          p.style.display = p.getAttribute('data-panel')===side ? '' : 'none';
        });
      });
    });
  });

  /* ---- self check: flat vs textural ---- */
  var scBtns = document.querySelectorAll('[data-sc]');
  scBtns.forEach(function(b){
    b.addEventListener('click',function(){
      var pick = b.getAttribute('data-sc');
      scBtns.forEach(function(o){ o.setAttribute('aria-pressed', o===b ? 'true':'false'); });
      var flat=document.getElementById('pp-sc-flat'), pit=document.getElementById('pp-sc-pit');
      if(flat){ flat.className='pp-sc-out'+(pick==='flat'?' pp-open pp-yes':''); }
      if(pit){ pit.className='pp-sc-out'+(pick==='pit'?' pp-open pp-no':''); }
    });
  });

  /* ---- tabs ---- */
  document.querySelectorAll('[data-tabs]').forEach(function(group){
    var tabs = group.querySelectorAll('.pp-tab');
    tabs.forEach(function(t){
      t.addEventListener('click',function(){
        tabs.forEach(function(o){
          o.setAttribute('aria-selected','false');
          var p=document.getElementById(o.getAttribute('aria-controls'));
          if(p) p.classList.remove('pp-act');
        });
        t.setAttribute('aria-selected','true');
        var panel=document.getElementById(t.getAttribute('aria-controls'));
        if(panel) panel.classList.add('pp-act');
      });
    });
  });

  /* ---- offer: subscribe toggle + variants ----
     Prices come through as INTEGER CENTS from Liquid (or as "$24.99" strings
     in the standalone demo). Both are handled; cents is authoritative. */
  var SHOP_MONEY = (window.Shopify && Shopify.money_format) || '${{amount}}';

  function toCents(v){
    if(v === null || v === undefined || v === '') return null;
    var str = String(v).trim();
    if(/^\d+$/.test(str)) return parseInt(str,10);            // liquid: cents
    var n = parseFloat(str.replace(/[^0-9.]/g,''));            // demo: "$24.99"
    return isNaN(n) ? null : Math.round(n*100);
  }
  function fmt(cents){
    if(cents === null) return '';
    var amount = (cents/100).toFixed(2);
    if(SHOP_MONEY.indexOf('{{') > -1){
      return SHOP_MONEY.replace(/\{\{\s*amount\s*\}\}/, amount)
                       .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents/100))
                       .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.',','));
    }
    return '$' + amount;
  }

  document.querySelectorAll('[data-buybox]').forEach(function(scope){
    if(!scope.querySelector('.pp-variant')) return;   // Kaching owns the offer — always true now
    var sub = scope.querySelector('.pp-ss-in');
    function subOn(){ return !!(sub && sub.checked); }

    function centsFor(b){
      var s = toCents(b.getAttribute('data-sub'));
      var o = toCents(b.getAttribute('data-once'));
      return (subOn() && s !== null) ? s : o;
    }

    function paint(){
      scope.classList.toggle('pp-sson', subOn());
      scope.querySelectorAll('.pp-variant').forEach(function(b){
        var out = b.querySelector('[data-vprice]');
        if(out) out.textContent = fmt(centsFor(b));
        var was = b.querySelector('[data-vwas]');
        if(was) was.textContent = fmt(toCents(b.getAttribute('data-once')));
      });

      var sel = scope.querySelector('.pp-variant[aria-pressed="true"]') || scope.querySelector('.pp-variant');
      if(!sel) return;

      var price = fmt(centsFor(sel)), el;
      scope.querySelectorAll('[data-price-out]').forEach(function(o){ o.textContent = price; });
      if((el = document.getElementById('pp-sticky-v'))) el.textContent = (sel.getAttribute('data-label')||'') + ' \u00b7 ' + price;

      /* --- the fields that actually reach the cart --- */
      var id = scope.querySelector('input[name="id"]');
      if(id && sel.getAttribute('data-vid')) id.value = sel.getAttribute('data-vid');

      var qty = scope.querySelector('input[name="quantity"]');
      if(qty) qty.value = sel.getAttribute('data-qty') || '1';

      var plan = scope.querySelector('input[name="selling_plan"]');
      if(plan) plan.value = subOn() ? (sel.getAttribute('data-plan') || '') : '';

      var btn = scope.querySelector('.pp-atc');
      if(btn){
        var avail = sel.getAttribute('data-available');
        var soldOut = avail === 'false';
        btn.disabled = soldOut;
        if(soldOut) btn.textContent = 'Sold out';
      }
    }

    scope.querySelectorAll('.pp-variant').forEach(function(b){
      b.addEventListener('click', function(){
        scope.querySelectorAll('.pp-variant').forEach(function(o){ o.setAttribute('aria-pressed','false'); });
        b.setAttribute('aria-pressed','true');
        paint();
      });
    });
    if(sub) sub.addEventListener('change', paint);
    paint();
  });

  /* ---- review carousel ---- */
  document.querySelectorAll('[data-car]').forEach(function(car){
    var rail=car.querySelector('[data-rail]');
    var prev=car.querySelector('.pp-car-prev');
    var next=car.querySelector('.pp-car-next');
    var dots=car.querySelector('[data-dots]');
    if(!rail) return;
    var cards=rail.children;

    function step(){
      if(!cards.length) return 300;
      var r=cards[0].getBoundingClientRect();
      var gap=parseFloat(getComputedStyle(rail).columnGap||getComputedStyle(rail).gap||16)||16;
      return r.width+gap;
    }
    function perView(){ return Math.max(1, Math.round(rail.clientWidth/step())); }
    function pages(){ return Math.max(1, cards.length-perView()+1); }

    if(dots){
      for(var i=0;i<pages();i++){
        var b=document.createElement('button');
        b.type='button';
        b.setAttribute('aria-label','Go to review '+(i+1));
        (function(n){ b.addEventListener('click',function(){ rail.scrollTo({left:n*step(),behavior:'smooth'}); }); })(i);
        dots.appendChild(b);
      }
    }
    function sync(){
      var idx=Math.round(rail.scrollLeft/step());
      if(dots) Array.prototype.forEach.call(dots.children,function(d,i){
        d.setAttribute('aria-current', i===idx ? 'true':'false');
      });
      if(prev) prev.disabled = rail.scrollLeft < 6;
      if(next) next.disabled = rail.scrollLeft > rail.scrollWidth-rail.clientWidth-6;
    }
    if(prev) prev.addEventListener('click',function(){ rail.scrollBy({left:-step(),behavior:'smooth'}); });
    if(next) next.addEventListener('click',function(){ rail.scrollBy({left:step(),behavior:'smooth'}); });
    rail.addEventListener('scroll',function(){
      clearTimeout(rail._t); rail._t=setTimeout(sync,90);
    },{passive:true});
    window.addEventListener('resize',function(){ clearTimeout(rail._r); rail._r=setTimeout(sync,150); },{passive:true});
    sync();
  });

  /* ---- how-to stepper ---- */
  document.querySelectorAll('[data-stepper]').forEach(function(g){
    var btns=g.querySelectorAll('[data-step]');
    btns.forEach(function(b){
      b.addEventListener('click',function(){
        var n=b.getAttribute('data-step');
        btns.forEach(function(o){o.setAttribute('aria-pressed', o===b?'true':'false')});
        g.querySelectorAll('[data-panel]').forEach(function(p){
          p.classList.toggle('pp-act', p.getAttribute('data-panel')===n);
        });
      });
    });
  });

  /* ---- interactive timeline ---- */
  document.querySelectorAll('[data-timeline]').forEach(function(g){
    var btns=g.querySelectorAll('[data-t]');
    btns.forEach(function(b){
      b.addEventListener('click',function(){
        var n=b.getAttribute('data-t');
        btns.forEach(function(o){o.setAttribute('aria-pressed', o===b?'true':'false')});
        g.querySelectorAll('[data-tp]').forEach(function(p){
          p.classList.toggle('pp-act', p.getAttribute('data-tp')===n);
        });
      });
    });
  });

  /* ---- problem -> resolution swap ---- */
  document.querySelectorAll('[data-swap] .pp-swap-i').forEach(function(b){
    b.addEventListener('click',function(){
      b.setAttribute('aria-pressed', b.getAttribute('aria-pressed')==='true' ? 'false':'true');
    });
  });

  /* ---- mechanism toggle ---- */
  document.querySelectorAll('[data-mech]').forEach(function(g){
    var btns=g.querySelectorAll('.pp-mech-toggle button');
    btns.forEach(function(b){
      b.addEventListener('click',function(){
        var side=b.getAttribute('data-side');
        btns.forEach(function(o){o.setAttribute('aria-pressed', o===b?'true':'false')});
        g.querySelectorAll('[data-panel]').forEach(function(p){
          p.style.display = p.getAttribute('data-panel')===side ? '' : 'none';
        });
      });
    });
  });

  /* ---- self check: flat vs textural ---- */
  var scBtns = document.querySelectorAll('[data-sc]');
  scBtns.forEach(function(b){
    b.addEventListener('click',function(){
      var pick = b.getAttribute('data-sc');
      scBtns.forEach(function(o){ o.setAttribute('aria-pressed', o===b ? 'true':'false'); });
      var flat=document.getElementById('pp-sc-flat'), pit=document.getElementById('pp-sc-pit');
      if(flat){ flat.className='pp-sc-out'+(pick==='flat'?' pp-open pp-yes':''); }
      if(pit){ pit.className='pp-sc-out'+(pick==='pit'?' pp-open pp-no':''); }
    });
  });

  /* ---- tabs ---- */
  document.querySelectorAll('[data-tabs]').forEach(function(group){
    var tabs = group.querySelectorAll('.pp-tab');
    tabs.forEach(function(t){
      t.addEventListener('click',function(){
        tabs.forEach(function(o){
          o.setAttribute('aria-selected','false');
          var p=document.getElementById(o.getAttribute('aria-controls'));
          if(p) p.classList.remove('pp-act');
        });
        t.setAttribute('aria-selected','true');
        var panel=document.getElementById(t.getAttribute('aria-controls'));
        if(panel) panel.classList.add('pp-act');
      });
    });
  });

  /* ---- offer: subscribe toggle + variants ---- */
  function money(x){ return parseFloat(String(x).replace(/[^0-9.]/g,'')) || 0; }

  document.querySelectorAll('[data-buybox]').forEach(function(scope){
    /* If Kaching (or any app) is driving the offer, our tier selector isn't rendered.
       Stand down rather than fight the widget for control of price + variant. */
    if(!scope.querySelector('.pp-variant')) return;
    var sub = scope.querySelector('.pp-ss-in');
    function on(){ return !sub || sub.checked; }
    function priceOf(b){
      var p = b.getAttribute('data-sub');
      var o = b.getAttribute('data-once') || b.getAttribute('data-price');
      return (on() && p) ? p : o;
    }
    function paint(){
      scope.classList.toggle('pp-sson', on());
      scope.querySelectorAll('.pp-variant').forEach(function(b){
        var out=b.querySelector('[data-vprice]');
        if(out) out.textContent = priceOf(b);
      });
      var sel = scope.querySelector('.pp-variant[aria-pressed="true"]') || scope.querySelector('.pp-variant');
      if(!sel) return;
      var p = priceOf(sel), el;
      scope.querySelectorAll('[data-price-out]').forEach(function(o){ o.textContent = p; });
      if((el=scope.querySelector('#pp-price'))) el.textContent = p;
      if((el=document.getElementById('pp-sticky-v'))) el.textContent = (sel.getAttribute('data-label')||'') + ' \u00b7 ' + p;
      var plan = scope.querySelector('input[name="selling_plan"]');
      if(plan) plan.value = on() ? (sel.getAttribute('data-plan') || '') : '';
      var hidden = scope.querySelector('input[name="id"]');
      var vid = sel.getAttribute('data-vid');
      if(hidden && vid) hidden.value = vid;
    }
    scope.querySelectorAll('.pp-variant').forEach(function(b){
      b.addEventListener('click',function(){
        scope.querySelectorAll('.pp-variant').forEach(function(o){ o.setAttribute('aria-pressed','false'); });
        b.setAttribute('aria-pressed','true');
        paint();
      });
    });
    if(sub) sub.addEventListener('change', paint);
    paint();
  });

  /* ---- scroll to buy box ---- */
  document.querySelectorAll('[data-scroll]').forEach(function(b){
    b.addEventListener('click',function(){
      var t=document.getElementById('pp-buy');
      if(t) window.scrollTo({top:t.getBoundingClientRect().top+window.pageYOffset-120,behavior:'smooth'});
    });
  });

  /* ---- gallery thumbs ---- */
  document.querySelectorAll('.pp-thumb').forEach(function(t){
    t.addEventListener('click',function(){
      document.querySelectorAll('.pp-thumb').forEach(function(o){o.classList.remove('pp-act')});
      t.classList.add('pp-act');
      var src=t.getAttribute('data-src'), main=document.getElementById('pp-main-img');
      if(src&&main) main.src=src;
    });
  });

  /* ---- reveal on scroll (desktop only — skipped on mobile for scroll perf) ---- */
  var isSmall = window.matchMedia('(max-width:899px)').matches;
  if(isSmall || !('IntersectionObserver' in window)){
    document.querySelectorAll('.pp-rise').forEach(function(el){el.classList.add('pp-vis')});
  } else {
    var io=new IntersectionObserver(function(es){
      es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('pp-vis'); io.unobserve(e.target); } });
    },{threshold:.1});
    document.querySelectorAll('.pp-rise').forEach(function(el){io.observe(el)});
  }

  /* ---- sticky buy bar: observer, not a scroll handler ----
     A scroll listener calling getBoundingClientRect() forces a synchronous
     layout on every frame. IntersectionObserver fires off the main thread. */
  var buy=document.getElementById('pp-buy'), bar=document.getElementById('pp-sticky');
  if(buy && bar){
    if('IntersectionObserver' in window){
      new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          bar.classList.toggle('pp-on', !e.isIntersecting && e.boundingClientRect.top < 0);
        });
      },{threshold:0}).observe(buy);
    } else {
      var t=null;
      window.addEventListener('scroll',function(){
        if(t) return;
        t=setTimeout(function(){ t=null;
          bar.classList.toggle('pp-on', buy.getBoundingClientRect().bottom < 0);
        },150);
      },{passive:true});
    }
  }

  /* ---- pause marquees when off-screen (saves battery + compositor work) ---- */
  if('IntersectionObserver' in window){
    var mo=new IntersectionObserver(function(es){
      es.forEach(function(e){
        e.target.style.animationPlayState = e.isIntersecting ? 'running' : 'paused';
      });
    },{threshold:0});
    document.querySelectorAll('.pp-ticker-in,.pp-badges-in').forEach(function(el){mo.observe(el)});
  }
})();
